"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataDictionaryError_1 = require("../../core/model/data-dictionary/DataDictionaryError");

var EntityStateFlag_1 = require("../../core/model/EntityStateFlag");

var GOSIdWithSiteBindings_1 = require("../model/GOSIdWithSiteBindings");

var GroupOfSites_1 = require("../model/GroupOfSites");

var GroupOfSitesConverter_1 = require("./GroupOfSitesConverter");
/**
 * Default implementation of {@link GroupOfSitesConverter group of site converter}.
 *
 * @author JMe
 */


var GroupOfSitesConverterImpl =
/*#__PURE__*/
function (_GroupOfSitesConverte) {
  _inherits(GroupOfSitesConverterImpl, _GroupOfSitesConverte);

  function GroupOfSitesConverterImpl() {
    _classCallCheck(this, GroupOfSitesConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(GroupOfSitesConverterImpl).apply(this, arguments));
  }

  _createClass(GroupOfSitesConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new GroupOfSites_1.GroupOfSites(GroupOfSites_1.GroupOfSites.schema.id.valueOf(conversions.documentToClassId(source)), GroupOfSites_1.GroupOfSites.schema.externalId.valueOfField(source), GroupOfSites_1.GroupOfSites.schema.name.valueOfField(source), conversions.asObjectList(source, 'sitesBinding', this.deserializeGroupOfSitesBinding(conversions)), conversions.asFlagSet(source.stateFlags, EntityStateFlag_1.EntityStateFlag));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        externalId: source.externalId,
        name: source.name,
        sitesBinding: conversions.asObjectArray(source, 'sitesBinding', this.serializeGroupOfSitesBinding(conversions)),
        stateFlags: source.stateFlags.serialize()
      });
      return result;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toIdWithBindings",
    value: function toIdWithBindings(source, conversions) {
      var id = GroupOfSites_1.GroupOfSites.schema.id.valueOf(conversions.documentToClassId(source));
      var bindings = conversions.asObjectList(source, 'sitesBinding', this.deserializeGroupOfSitesBinding(conversions));
      return new GOSIdWithSiteBindings_1.GOSIdWithSiteBindings(id, bindings);
    }
  }, {
    key: "deserializeGroupOfSitesBinding",
    value: function deserializeGroupOfSitesBinding(conversions) {
      return function (document) {
        if (!document.siteId) {
          throw new DataDictionaryError_1.DataDictionaryError("siteId is missing!");
        }

        if (!document.validFrom) {
          throw new DataDictionaryError_1.DataDictionaryError("validFrom is missing!");
        }

        return {
          siteId: conversions.toClassReferenceId(document.siteId),
          validFrom: conversions.toDate(document.validFrom),
          validTo: conversions.toDate(document.validTo)
        };
      };
    }
  }, {
    key: "serializeGroupOfSitesBinding",
    value: function serializeGroupOfSitesBinding(conversions) {
      return function (object) {
        if (typeof object !== 'object' || object === null) {
          return null;
        }

        return {
          siteId: conversions.toDocumentReferenceId(object.siteId),
          validFrom: conversions.fromDate(object.validFrom),
          validTo: object.validTo !== null ? conversions.fromDate(object.validTo) : null
        };
      };
    }
  }]);

  return GroupOfSitesConverterImpl;
}(GroupOfSitesConverter_1.GroupOfSitesConverter);

exports.GroupOfSitesConverterImpl = GroupOfSitesConverterImpl;